export default __webpack_public_path__ + "static/media/Rubik-BoldItalic.c7f22a77.ttf";